<template>
  <div>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <label class="vs-input--label">{{ $t('companySelector.label') }} *</label>
    <TreeSelect
        :options="companies"
        :disable-branch-nodes="true"
        :show-count="true"
        :value="value"
        name="company"
        v-validate="'required'"
        :placeholder="$t('companySelector.placeholder')"
        :disabled="isDisable"
        @select="select"/>
    <small v-if="hasNoActiveCompanies" class="has-text-danger">
      {{ $t('companySelector.noActiveCompanies') }}
    </small>
  </div>
</template>

<script>
import TreeSelect from "@riophae/vue-treeselect";
import {getParameterByName} from "@/global/utils";
import {get as getProp} from "object-path";
import CompanyEndpoint from "@/endpoints/core/CompanyEndpoint";
import CurrentCompanyStorage from "@/global/session/CurrentCompanyStorage";
import {containsCompany} from "@/global/company/companyTree";

export default {
  name: "CompanySelector",
  components: {TreeSelect},
  props: ["value", "isDisable"],
  data: () => ({
    isLoading: true,
    loadFailed: false,
    companies: [],
  }),
  computed: {
    // Si la consulta falló ya se mostró el toast de error: no se afirma que no haya empresas vigentes.
    hasNoActiveCompanies() {
      return !this.isLoading && !this.loadFailed && this.companies.length === 0;
    },
  },
  async mounted() {
    try {
      // v1/list/tree ya excluye las vencidas y sus hijas: el front no filtra.
      const list = await CompanyEndpoint.listCompaniesV1();
      if (list === null) {
        // Sin restaurar: con el árbol vacío se borraría de localStorage una empresa que puede seguir vigente.
        this.loadFailed = true;
        return;
      }
      this.companies = list;
      this.restoreCurrentCompany();
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    /**
     * Regla de negocio: la empresa activa guardada solo se restaura si sigue vigente (está en el árbol).
     * Efecto: si venció se borra de localStorage, así axiosConfig deja de enviarla en el header companyId.
     */
    restoreCurrentCompany() {
      if (getParameterByName("companyId")) {
        return;
      }
      const storedId = CurrentCompanyStorage.get();
      if (!containsCompany(this.companies, storedId)) {
        CurrentCompanyStorage.clear();
        this.$emit("input", null);
        return;
      }
      this.$emit("input", storedId);
    },
    select(company) {
      this.selectCompany(getProp(company, "code"));
    },
    selectCompany(companyId) {
      if (companyId) {
        CurrentCompanyStorage.set(companyId);
      }
      this.$emit("input", companyId);
    },
  },
};
</script>
